import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
// 防止路由重复点击报错
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};
// replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch((err) => err);
};
const routes = [
  {
    path: "/",
    redirect: "/page",
  },

  {
    path: "/page",
    name: "page",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/page.vue"),
    redirect: "/myPlan",
    children: [
      {
        path: "/myPlan",
        component: () => import("../views/myPlan/index.vue"),
        name: "myPlan",
      },
      {
        path: "/schemas",
        component: () => import("../views/schemas/index.vue"),
        name: "schemas",
      },
      {
        path: "/selectVC",
        component: () => import("../views/schemas/selectVC.vue"),
        name: "selectVC",
      },
      {
        path: "/creatSchema",
        component: () => import("../views/schemas/creatSchema.vue"),
        name: "creatSchema",
      },
      {
        path: "/creatSchemaConfirm",
        component: () => import("../views/schemas/creatSchemaConfirm.vue"),
        name: "creatSchemaConfirm",
      },
      {
        path: "/editSchemas",
        component: () => import("../views/schemas/editSchemas.vue"),
        name: "editSchemas",
      },
    ],
  },

  {
    path: "/page2",
    name: "page2",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/page2.vue"),
    children: [
      {
        path: "/purchaseAdditionalSeats",
        component: () => import("../views/myPlan/purchaseAdditionalSeats.vue"),
        name: "purchaseAdditionalSeats",
      },
      {
        path: "/subscriptionPayment",
        component: () => import("../views/myPlan/subscriptionPayment.vue"),
        name: "subscriptionPayment",
      },
      {
        path: "/reduceSeats",
        component: () => import("../views/myPlan/reduceSeats.vue"),
        name: "reduceSeats",
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

export default router;
